module.exports = __webpack_public_path__ + "static/media/line-size-3.44ec6023.svg";